function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-944e408c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./modal.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./modal.vue"),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/modal/modal.vue
// module id = 226
// module chunks = 1